module.exports = __webpack_public_path__ + "static/media/mEdutainmentBanner.fe91a969.svg";